//LOGO
export const LOGO = '/assets/images/logo.png'
export const SITE_NAME = 'Iquippo'

export const FALLBACK_IMAGE = (e) => {
    e.target.src = '/assets/images/noImage.png'
}
